// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.streams-drawer-tracking-bar progress-bar-leader,
.streams-drawer-tracking-bar progress-bar-follower {
  background-color: #007c92;
}
`, "",{"version":3,"sources":["webpack://./app/streams-drawer/streams-drawer-tracking-bar/streams-drawer-tracking-bar.less"],"names":[],"mappings":"AAEA;;EAGI,yBAAA;AAFJ","sourcesContent":["@import (reference) '../../../css/unison';\n\n.streams-drawer-tracking-bar {\n  progress-bar-leader, progress-bar-follower {\n    // TODO: Should this use a different shade?\n    background-color: @cu-color-primary;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
